<template>
	<div class="operatDemo-box">
		
		<div v-if="curWebsite.type == 1 || curWebsite.type == 8" v-show="operatype == 'total'">
			<div class="operatDemo-continue" v-show="operatBtn2" @click="operatBtn1=true;operatBtn2=false">步骤演练</div>
			<div :class="operatBtn1?'operatDemo operatDemo-fixednum demo'+curWebsite.type:'operatDemo animeKey demo'+curWebsite.type" id='operatDemo'>
				<h2 class="operat-title"><span class=" ">产业招商大脑专业版核心功能：</span><span class="basefont-nocur por">操作指引<i class="right-icon-logo operatIcon"></i></span></h2>
				<span class="hidebtn" @click="operatBtn1=false;operatBtn2=false;">关闭</span>
				<table border="0" cellspacing="0" cellpadding="0" class="operate-table">
					<tr>
						<th colspan="2">招商工作场景</th>
						<th>功能说明</th>
						<th>操作指引</th>
					</tr>
					<tr>
						<td rowspan="4">
							<h5 class="title1">看机会</h5>
						</td>
						<td>看上市公司投资动态</td>
						<td>查看A股5000多家上市公司，在各个产业的最新投资项目动态，把握产业招商机会</td>
						<td><span class="curp" @click="getCurrentList(1)">只需6步 ></span></td>
					</tr>
					<tr>
						<td>看企业拿地投资动态</td>
						<td>通过关键词查询，分行业查看，全国所有拿地投资项目最新动态，把握产业招商机会</td>
						<td><span class="curp" @click="getCurrentList(2)">只需10步 ></span></td>
					</tr>
					<tr>
						<td>看城市产业转移动态</td>
						<td>查看北京、上海和深圳等重点城市的产业转移动态，把握产业转移中的招商机会</td>
						<td><span class="curp" @click="getCurrentList(3)">只需8步></span></td>
					</tr>
					<tr>
						<td>看企业投资布局和动态</td>
						<td>查看某家龙头企业的全国拿地投资布局、投资动态，挖掘重点企业的招商机会</td>
						<td><span class="curp" @click="getCurrentList(4)">只需8步></span></td>
					</tr>
					<tr>
						<td rowspan="5">
							<h5 class="title1">找企业</h5>
						</td>
						<td>从全国产业图谱找企业</td>
						<td>选择您关注的重点产业链，从产业链某个环节查找龙头企业，并查看企业详细信息</td>
						<td><span class="curp" @click="getCurrentList(5)">只需11步></span></td>
					</tr>
					<tr>
						<td>本地产业链补链找企业</td>
						<td>自动诊断本地产业链强链补链环节，查看本地企业详情，查看补链招商企业名单</td>
						<td><span class="curp" @click="getCurrentList(6)">只需10步></span></td>
					</tr>
					<tr>
						<td>大城市驻点招商找企业</td>
						<td>到北上广深等发达大城市驻点招商，快速找到城市的重点产业及重点企业，查看企业详情</td>
						<td><span class="curp" @click="getCurrentList(7)">只需6步></span></td>
					</tr>
					<tr>
						<td>资本招商找专业投资机构</td>
						<td>查看头部专业投资机构的最新投资项目动态，了解产业前沿投融资动态，查看机构详情信息</td>
						<td><span class="curp" @click="getCurrentList(8)">只需8步></span></td>
					</tr>
					<tr>
						<td>科技招商找科技创新企业</td>
						<td>查找最新获得融资的科技创新企业，为政府科技招商、资本招商提供精准招商目标</td>
						<td><span class="curp" @click="getCurrentList(9)">只需8步></span></td>
					</tr>
					<tr>
						<td rowspan="2">
							<h5 class="title1">做研判</h5>
						</td>
						<td>研判企业投资意向</td>
						<td>通过企业产品及业务、投资动态和投资画像算法，在与企业接触前，就事先判断企业投资意向</td>
						<td><span class="curp" @click="getCurrentList(10)">只需7步></span></td>
					</tr>
					<tr>
						<td>评估企业投资实力</td>
						<td>通过企业综合实力、财务实力、投资布局和研发投入等信息，对企业快速尽调，进行项目研判</td>
						<td><span class="curp" @click="getCurrentList(11)">只需7步></span></td>
					</tr>
					<tr>
						<td rowspan="2">
							<h5 class="title1">建联系</h5>
						</td>
						<td>企业-城市 关系计算器</td>
						<td>计算目标招商企业与本城市重点企业的供应链关系或股权关系，通过本地企业，进行以商招商</td>
						<td><span class="curp" @click="getCurrentList(12)">只需16步></span></td>
					</tr>
					<tr>
						<td>企业-企业单个关系计算器</td>
						<td>计算您熟悉的单个外地企业与目标招商之间的链接关系，找出潜在关系链，进行以商招商</td>
						<td><span class="curp" @click="getCurrentList(13)">只需9步></span></td>
					</tr>
					<!-- <tr>
						<td>企业-企业批量关系计算器</td>
						<td>计算您熟悉的几十家外地企业与目标招商之间的链接关系，找出潜在关系链，进行以商招商</td>
						<td><span class="curp" @click="getCurrentList(14)">只需20步></span></td>
					</tr> -->
				</table>
				<div class="operat_list" v-if="curWebsite.type == 1 || curWebsite.type == 8" v-show="showoperatBtn">
				<div v-for="(list,i) in zs_current_list.children" :key="i" v-show="zs_current_list.step == i" class="por" >
					<span class="hidebtn1" @click="showoperatBtn=false">返回<br/>首页</span> 
					<span class="hidebtn1 hidebtn2" @click="operatBtn2=true;operatBtn1=false;">演练<br/>操作</span>
					<!-- ../../assets/operation/zs/a1.jpg -->
					<div class="imgbox"><img :src="list.imgsrc" alt="" class="operat_img"></div>
					<h4  :class="titlechagne? 'operat_title spe_operat_title':'operat_title'" >
						<strong class="redfont">{{zs_current_list.title}}</strong>
						<span class="basefont-nocur" @click="showoperatBtn=false">操作指引</span> 
						</h4>
					<div class="btnbox">
						<span class="returnbtn" @click="getCurrentList(zs_current_type-1,'back');titlechagne=true" v-show="i==0 && zs_current_type!=1"> &lt; 上一个工作场景</span>
						<span class="prevbtn" @click="zs_current_list.step--;titlechagne=false"  v-show="i!=0">上一步</span>
						<span class="nextbtn" @click="zs_current_list.step++;titlechagne=false" v-show="i<(zs_current_list.children.length-1)">下一步</span>
						<span class="returnbtn" @click="getCurrentList(zs_current_type+1,'next');titlechagne=true" v-show="i==(zs_current_list.children.length-1) && zs_current_type<13">下一个工作场景 &gt;</span>
						<span class="returnbtn"  @click="showoperatBtn=false" v-show="i==(zs_current_list.children.length-1) && zs_current_type==13">返回首页 ></span>
					</div>
				</div>
			</div> 
		</div>  
	</div>
	<!-- 招商大脑 试用账户 易用版与专业版 试用指引独立展示 仅在用户初次登录时展示 -->
	<div v-if="curWebsite.type == 1 || curWebsite.type == 8"  v-show="operatype == 'zsdn_version'">
			<!-- <div class="operatDemo-continue" v-show="operatBtn2" @click="operatBtn1=true;operatBtn2=false">步骤演练</div> -->
			<div :class="operatBtn1?'operatDemo operatDemo-fixednum demo'+curWebsite.type:'operatDemo animeKey demo'+curWebsite.type" id='operatDemo-zsdn'> 
				<div class="operat_list" v-if="curWebsite.type == 1 || curWebsite.type == 8" >
				<div v-for="(list,i) in zs_current_list_version.children" :key="i" v-show="zs_current_list_version.step == i" class="por" >
				<!-- 	<span class="hidebtn1" @click="showoperatBtn=false">返回<br/>首页</span> 
					<span class="hidebtn1 hidebtn2" @click="operatBtn2=true;operatBtn1=false;">演练<br/>操作</span> -->
					<!-- ../../assets/operation/zs/a1.jpg -->
					<div class="imgbox"><img :src="list.imgsrc" alt="" class="operat_img"></div>
					<h4  :class="titlechagne? 'operat_title spe_operat_title':'operat_title'" >
						<strong class="redfont">{{zs_current_list_version.title}}</strong>
						<span class="basefont-nocur" @click="showoperatBtn=false">操作指引</span> 
						</h4>
					<div class="btnbox">
						<!-- <span class="returnbtn" @click="getCurrentList(zs_current_type-1,'back');titlechagne=true" v-show="i==0 && zs_current_type!=1"> &lt; 上一个工作场景</span> -->
						<span class="prevbtn" @click="zs_current_list_version.step--;titlechagne=false"  v-show="i!=0">上一步</span>
						<span class="nextbtn" @click="zs_current_list_version.step++;titlechagne=false" v-show="i<(zs_current_list_version.children.length-1)">下一步</span>
						<!-- <span class="returnbtn" @click="getCurrentList(zs_current_type+1,'next');titlechagne=true" v-show="i==(zs_current_list.children.length-1) && zs_current_type<13">下一个工作场景 &gt;</span> -->
						<span class="returnbtn"  @click="operatBtn1=false" v-show="i==(zs_current_list_version.children.length-1)">退出</span>
					</div>
				</div>
			</div> 
		</div>  
	</div>
	<!-- 研究大脑的操作演练步骤 -->
	<div v-if="curWebsite.type == 6">
		<div :class="operatBtn1?'operatDemo operatDemo-fixednum demo'+curWebsite.type:'operatDemo animeKey demo'+curWebsite.type" id='operatDemo'>
			<h2 class="operat-title"><span class=" ">产业研究大脑核心功能：</span><span class="basefont-nocur por">操作指引<i class="right-icon-logo operatIcon"></i></span></h2>
			<span class="hidebtn" @click="operatBtn1=false;operatBtn2=false;">关闭</span>
		 
			<table border="0" cellspacing="0" cellpadding="0" class="operate-table" > 
				<tr>
					<th colspan="2">产业研究工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td rowspan="3">
						<h5 class="title1">做产业研究</h5>
					</td>
					<td><span class="curp" @click="navClickLink({url: 'report'})">深度产业研究</span></td>
					<td><p>覆盖所有重点、热点行业，<strong>1000多份深度行业研究报告</strong>，可随时在线阅读，全面深入理解各个行业</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/allchain?type=10561')">产业链研究</span></td>
					<td><p>有<strong>240多条产业链图谱</strong>，能高效查找产业链各环节重点企业，并随时查看企业详细信息，产业链全景一览无余</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="navClickLink({url: 'invest'})">投资趋势研究</span></td>
					<td><p>通过独家<strong>上市公司投资数据库、企业拿地投资数据库</strong>，把握各个产业投资趋势，分析龙头企业投资动向</p></td>
				</tr>
				<tr>
					<td rowspan="4">
						<h5 class="title1">做企业研究</h5>
					</td>
					<td><span class="curp" @click="judgeLink('/enterpriseList?type=9')">上市公司研究</span></td>
					<td><p>通过<strong>5200多家A股上市企业库</strong>，高效查找各行业、各地区上市公司数据，并查看企业战略方向和投资布局；</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/enterpriseList?type=1')">龙头企业研究</span></td>
					<td><p>有包括<strong>500强、央企、国企在内的5万多家（非A股上市）龙头企业</strong>，查看每家企业投资动态和投资布局</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/enterpriseList?type=2')">创新企业研究</span></td>
					<td><p><strong>7万多家获得融资的创新企业库</strong>，可以分地区、分行业进行高级查询，快速查找优质投资标的</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/forcapEnterprise')">外资企业研究</span></td>
					<td><p>高效查找13万家外资企业、以及1600多家外资企业总部，查看该企业在国内的投资布局和投资动态</p></td>
				</tr> 
				<tr>
					<td rowspan="4">	<h5 class="title1">监测产业动态</h5></td>
					<td><span class="curp" @click="judgeLink('/investment-clues3')">创新企业融资动态</span></td>
					<td><p>查看最近12个月，<strong>每个月最新获得融资的科技型创新企业</strong>，可分阶段、分城市查询</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/investment-institutions')">专业机构投资动态</span></td>
					<td><p>查找全国所有<strong>一级市场专业投资机构</strong>，并查看每家机构的<strong>投资方向和最新投资项目</strong>；可分城市、分行业查询</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/markenterprise')">上市公司投资动态</span></td>
					<td><p>实时监测所有上市公司公告的<strong>最新投资项目</strong>，对本行业标杆企业的的<strong>投资动态</strong>一目了然</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/landenterprise')">企业拿地投资动态</span></td>
					<td><p>动态监测所有企业的<strong>拿地投资动态</strong>，对行业重点企业的<strong>投资布局、产能扩张动态</strong>全面掌握</p></td>
				</tr> 
				<tr>
					<td rowspan="4">	<h5 class="title1">产业排行榜</h5></td>
					<td><span class="curp" @click="judgeLink('/investment-clues7')">重点产业城市排行</span></td>
					<td>	<p>通过产业、企业大数据，在选定重点产业后，对全国重点城市进行排行，各城市产业竞争格局，一目了然</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/investment-clues5')">热点产业企业排行</span></td>
					<td><p>通过产业、企业大数据，选定任何区域、任何城市、任何产业，都可以立即自动对企业进行智能排序</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('/investment-clues6')">重点城市产业排行</span></td>
					<td><p>通过产业、企业大数据，对国内前20个重点城市，自动分析每个城市重点产业，及该产业的重点企业数量</p></td>
				</tr>
				<tr>
					<td><span class="curp" @click="judgeLink('investment-clues1')">重点区域企业排行</span></td>
					<td><p>对长三角、珠|三角、京津冀、成渝及闽东南5个重点区域及相关城市进行分析，智能筛选出重点龙头企业</p></td>
				</tr> 
		</table> 
		</div>
	</div>
	<div v-if="curWebsite.type == 4">
		<div :class="operatBtn1?'operatDemo operatDemo-fixednum demo'+curWebsite.type:'operatDemo animeKey demo'+curWebsite.type" id='operatDemo'>
			<h2 class="operat-title"><span class=" ">产业信贷大脑核心功能：</span><span class="basefont-nocur por">操作指引<i class="right-icon-logo operatIcon"></i></span></h2>
			<span class="hidebtn" @click="operatBtn1=false;operatBtn2=false;">关闭</span> 
			<table border="0" cellspacing="0" cellpadding="0" class="operate-table" > 
			<tr>
				<th colspan="2">信贷业务工作场景</th>
				<th>功能说明</th>
			</tr>
			<!--  -->
			<tr>
				<td rowspan="3"><h5 class="title1">选产业</h5></td>
				<td><span class="curp" @click="judgeLink('/industryInvestmentWindow')">产业投资窗口期-选产业</span></td>
				<td><p>通过大数据筛选出当前处于<strong>投资(融资)窗口期的行业</strong>，作为重点业务方向参考</p></td>
			</tr>
			<tr> 
				<td><span class="curp" @click="judgeLink('/totalEnterprises')">筛选城市支柱产业-选产业</span></td>
				<td><p>通过企业大数据，筛选出本城市或其他城市的<strong>支柱产业</strong>，作为业务方向参考</p></td>
			</tr>
			<tr> 
				<td><span class="curp" @click="navClickLink({url: 'report'})">行业报告库看产业-选产业</span></td>
				<td><p>报告库共有<strong>900多份行业研究报告</strong>，覆盖所有重点热点行业，便于快速了解行业</p></td>
			</tr>
			<!--  -->
			<tr>
				<td rowspan="6"><h5 class="title1">找企业</h5></td>
				<td><span class="curp" @click="judgeLink('/allBuildings')">园区楼宇-找企业</span></td>
				<td><p>通过<strong>全市所有园区和楼宇</strong>的搜索，筛查有实力的和发展中的优质企业客户资源</p></td>
			</tr>
			<tr> 
				<td><span class="curp" @click="judgeLink('/allchain')">产业链图谱-找企业</span></td>
				<td><p>从<strong>全国产业图谱</strong>找行业龙头企业;从<strong>本市产业链图谱</strong>，找本市产业链各环节企业</p></td>
			</tr>
			<tr> 
				<td><span class="curp" @click="judgeLink('/investment-clues2')">产业链金融-找企业</span></td>
				<td><p>根据<strong>本地龙头企业上下游名单</strong>，查找被龙企业带动的受益的产业链上下游企业</p></td>
			</tr>
			<tr> 
				<td><span class="curp" @click="judgeLink('/investment-clues3')">投贷联动-找企业</span></td>
				<td><p>企业获投资充实资本金后，就有资信获得配套信贷支持，<strong>实现投资和贷款联动</strong></p></td>
			</tr>
			<tr> 
				<td><span class="curp" @click="judgeLink('/enterpriseInvestmentWindow')">企业投资窗口期-找企业</span></td>
				<td><p>业绩高速成长、获大额融资或拟上市的企业，处于投资扩张期，信贷需求自然强烈</p></td>
			</tr>
			<tr> 
				<td><span class="curp" @click="judgeLink('/investment-clues8')">根据投资排行榜-找企业</span></td>
				<td><p>频繁拿地投资、以及投资项目多的企业，融资的需求自然大，所以是<strong>重要信贷客户</strong></p></td>
			</tr>
  <tr>
  	<td><h5 class="title1">做研判</h5></td>
  	<td><span class="curp" @click="judgeLink('/investment-clues5')">研判企业融资需求</span></td>
  	<td><p>算法逻辑，行业有大机会，龙头企业一定会投资，所以就有融资需求</p></td>
  </tr>
  <tr>
  	<td><h5 class="title1">建联系</h5></td>
  	<td><span class="curp" @click="judgeLink('/relationalcalculator')">企业-企业 关系计算器</span></td>
  	<td><p>通过认识的企业，计算与目标企业的关系链，再让中间企业介绍，联系目标企业</p></td>
  </tr> 
			</table>
		</div>
	</div>
</div>
</template>

<script>
	export default {
		name: 'operatDemo',
		data() {
			return {
				title: "操作指引",
				auto:false, 
				operatype:"total",//默认total 招商大脑试用版初次登录展示的易用专业版只展示一次 zsdn_version
				curWebsite:this.$api.getWebsiteType(),
				userData:this.getuseriformation(),
				// this.edition=this.userdata.edition;//区分正式或者试用账户
				searchtext: "",
				operatBtn1:false,operatBtn2:false,
				showoperatBtn:false,
				zs_current_type:1,
				titlechagne:false,//用于每一大步切换时title的动画显示
				zs_current_list_version:{
					 title:"易用版与专业版切换",type:1,step:0,allstep:3,children:[
						{name:"a",imgsrc:require('../../assets/operation/zs_version/a1.png')},
						{name:"a",imgsrc:require('../../assets/operation/zs_version/a2.png')},
						{name:"a",imgsrc:require('../../assets/operation/zs_version/a3.png')}, 
					] 
				},
				zs_operat_list:[
					{title:"看上市公司动态",type:1,step:0,allstep:4,children:[
						{name:"a",imgsrc:require('../../assets/operation/zs/a1.jpg')},
						{name:"a",imgsrc:require('../../assets/operation/zs/a2.png')},
						{name:"a",imgsrc:require('../../assets/operation/zs/a3.png')},
						{name:"a",imgsrc:require('../../assets/operation/zs/a4.png')},
					]},
					{title:"看企业拿地投资动态",type:2,step:0,allstep:6,children:[
						{name:"b",imgsrc:require('../../assets/operation/zs/b1.png')},
						{name:"b",imgsrc:require('../../assets/operation/zs/b2.png')},
						{name:"b",imgsrc:require('../../assets/operation/zs/b3.png')},
						{name:"b",imgsrc:require('../../assets/operation/zs/b4.png')},
						{name:"b",imgsrc:require('../../assets/operation/zs/b5.png')},
						{name:"b",imgsrc:require('../../assets/operation/zs/b6.png')},
					]},
					{title:"看城市产业转移动态",type:3,step:0,allstep:4,children:[
						{name:"c",imgsrc:require('../../assets/operation/zs/c1.png')},
						{name:"c",imgsrc:require('../../assets/operation/zs/c2.png')},
						{name:"c",imgsrc:require('../../assets/operation/zs/c3.png')},
						{name:"c",imgsrc:require('../../assets/operation/zs/c4.png')},
					]},
					{title:"看企业投资布局和动态",type:4,step:0,allstep:6,children:[
						{name:"d",imgsrc:require('../../assets/operation/zs/d1.png')},
						{name:"d",imgsrc:require('../../assets/operation/zs/d2.png')},
						{name:"d",imgsrc:require('../../assets/operation/zs/d3.png')},
						{name:"d",imgsrc:require('../../assets/operation/zs/d4.png')},
						{name:"d",imgsrc:require('../../assets/operation/zs/d5.png')},
						{name:"d",imgsrc:require('../../assets/operation/zs/d6.png')},
					]},
					{title:"从全国产业图谱找企业",type:5,step:0,allstep:4,children:[
						{name:"e",imgsrc:require('../../assets/operation/zs/e1.png')},
						{name:"e",imgsrc:require('../../assets/operation/zs/e2.png')},
						{name:"e",imgsrc:require('../../assets/operation/zs/e3.png')},
						{name:"e",imgsrc:require('../../assets/operation/zs/e4.png')}, 
					]},
					{title:"本地产业链补链找企业",type:6,step:0,allstep:6,children:[
						{name:"f",imgsrc:require('../../assets/operation/zs/f1.png')},
						{name:"f",imgsrc:require('../../assets/operation/zs/f2.png')},
						{name:"f",imgsrc:require('../../assets/operation/zs/f3.png')},
						{name:"f",imgsrc:require('../../assets/operation/zs/f4.png')},
						{name:"f",imgsrc:require('../../assets/operation/zs/f5.png')},
						{name:"f",imgsrc:require('../../assets/operation/zs/f6.png')},
					]},
					{title:"大城市驻点招商找企业",type:7,step:0,allstep:4,children:[
						{name:"g",imgsrc:require('../../assets/operation/zs/g1.png')},
						{name:"g",imgsrc:require('../../assets/operation/zs/g2.png')},
						{name:"g",imgsrc:require('../../assets/operation/zs/g3.png')},
						{name:"g",imgsrc:require('../../assets/operation/zs/g4.png')}, 
					]},
					{title:"资本招商找专业投资机构",type:8,step:0,allstep:6,children:[
						{name:"h",imgsrc:require('../../assets/operation/zs/h1.png')},
						{name:"h",imgsrc:require('../../assets/operation/zs/h2.png')},
						{name:"h",imgsrc:require('../../assets/operation/zs/h3.png')},
						{name:"h",imgsrc:require('../../assets/operation/zs/h4.png')}, 
						{name:"h",imgsrc:require('../../assets/operation/zs/h5.png')}, 
						{name:"h",imgsrc:require('../../assets/operation/zs/h6.png')}, 
					]},
					{title:"科技招商找科技创新企业",type:9,step:0,allstep:6,children:[
						{name:"i",imgsrc:require('../../assets/operation/zs/i1.png')},
						{name:"i",imgsrc:require('../../assets/operation/zs/i2.png')},
						{name:"i",imgsrc:require('../../assets/operation/zs/i3.png')},
						{name:"i",imgsrc:require('../../assets/operation/zs/i4.png')}, 
						{name:"i",imgsrc:require('../../assets/operation/zs/i5.png')}, 
						{name:"i",imgsrc:require('../../assets/operation/zs/i6.png')}, 
					]},
					{title:"研判企业投资意向",type:10,step:0,allstep:5,children:[
						{name:"j",imgsrc:require('../../assets/operation/zs/j1.png')},
						{name:"j",imgsrc:require('../../assets/operation/zs/j2.png')},
						{name:"j",imgsrc:require('../../assets/operation/zs/j3.png')},
						{name:"j",imgsrc:require('../../assets/operation/zs/j4.png')}, 
						{name:"j",imgsrc:require('../../assets/operation/zs/j5.png')}, 
					]},
					{title:"评估企业投资实力",type:11,step:0,allstep:5,children:[
						{name:"k",imgsrc:require('../../assets/operation/zs/k1.png')},
						{name:"k",imgsrc:require('../../assets/operation/zs/k2.png')},
						{name:"k",imgsrc:require('../../assets/operation/zs/k3.png')},
						{name:"k",imgsrc:require('../../assets/operation/zs/k4.png')}, 
						{name:"k",imgsrc:require('../../assets/operation/zs/k5.png')}, 
					]},
					{title:"企业-城市 关系计算器",type:12,step:0,allstep:8,children:[
						{name:"l",imgsrc:require('../../assets/operation/zs/l1.png')},
						{name:"l",imgsrc:require('../../assets/operation/zs/l2.png')},
						{name:"l",imgsrc:require('../../assets/operation/zs/l3.png')},
						{name:"l",imgsrc:require('../../assets/operation/zs/l4.png')}, 
						{name:"l",imgsrc:require('../../assets/operation/zs/l5.png')}, 
						{name:"l",imgsrc:require('../../assets/operation/zs/l6.png')}, 
						{name:"l",imgsrc:require('../../assets/operation/zs/l7.png')}, 
						{name:"l",imgsrc:require('../../assets/operation/zs/l8.png')}, 
					]},
					{title:"企业-企业 单个关系计算器",type:13,step:0,allstep:4,children:[
						{name:"m",imgsrc:require('../../assets/operation/zs/m1.png')},
						{name:"m",imgsrc:require('../../assets/operation/zs/m2.png')},
						{name:"m",imgsrc:require('../../assets/operation/zs/m3.png')},
						{name:"m",imgsrc:require('../../assets/operation/zs/m4.png')},  
					]},
					// {title:"企业-企业 批量关系计算器",type:14,step:0,allstep:8,children:[
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n1.png')},
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n2.png')},
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n3.png')},
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n4.png')}, 
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n5.png')}, 
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n6.png')}, 
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n7.png')}, 
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n8.png')}, 
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n9.png')}, 
					// 	{name:"n",imgsrc:require('../../assets/operation/zs/n10.png')}, 
					// ]},
				],
				zs_current_list:{},
			}
		},
		props: {
			name: "",
			userdata:{type:Object},
			// operatBtn:{default:false,require:true},
		},
	watch:{
		operatBtn1:{
			handler(newValue,oldValue){  
				
				var idname=this.operatype == 'zsdn_version' ? 'operatDemo-zsdn' : 'operatDemo'; 
				console.log(this.operatype,idname);
				console.log(document.getElementById(idname))
			if(newValue == false){
				setTimeout(()=>{
					document.getElementById(idname).style = 'display:none;';
				},2200)
			}else{
				document.getElementById(idname).style = 'display:block';
			}
			}  
		}, 
	}, 
		created() {
			var that=this;
			this.bus.$on('operatDemo', function(bool,type) {   
				that.operatBtn1 = !!bool;  
				that.operatype=type;
				console.log('operatDemo',that.operatBtn1,that.operatype);
			});
			// console.log('operatDemo',this.userdata.loginNum,this.userdata.zsdn_version_num);
			// console.log('abc',this.userData.edition)
		}, 
		mounted() {
			// this.getCurrentList(1);
		},
		methods:{
			judgeLink(url){
				var websiteHref = window.location.hash;  
				this.routerself(url);
				this.operatBtn1=false; 
			},
			//招商大脑的操作演练 获取当前的步骤数值
			getCurrentList(type,direction){ 
				this.zs_current_list=this.zs_operat_list[type-1];
				if(direction == 'back'){
					this.zs_current_list.step=this.zs_current_list.children.length-1;
				}else{
					this.zs_current_list.step=0;
				} 
				this.showoperatBtn=true;
				this.zs_current_type=type;
			},
			//研究大脑等其他大脑的表格跳转去报告 投资项目库
			navClickLink(item) {
				var url = item.url;
				if (url == 'loginout') {
					this.logout()
				} else if (url == 'report') {
					window.open(this.$api.getReportUrl() + '&token=' + this.userdata.token); //研究报告库外部跳转
				} else if (url == 'reportList') {
					window.open(this.$api.getReportListUrl(item.reportId) + '&token=' + this.userdata.token); //研究报告库外部跳转
				} else if (url == "land" || url == 'invest') {
					window.open(this.$api.getBigDataUrl(url) + '&token=' + this.userdata.token); // 外部跳转拿地信息库 投资项目库跳转
				} else if (url == 'freeReport') { //跳转到免费报告库
					window.open(this.$api.getFreeReportUrl(item.reportId));
				} else {
					this.nums++;
					if (url.indexOf('enterpriseList') > 0) {
						if (url.indexOf('?') < 0) {
							url = url + '?t=' + this.nums;
						} else {
							url = url + '&t=' + this.nums;
						}
					}
					this.routerself(url);
				}
			},
		},
		
	}
</script>

<style scoped>
	.operatDemo{ 
		display: none;
	}
	.operatDemo-fixednum{
		position: fixed;left: 0;top: 0;z-index: 21;
	}
	.scaleAin{
		transform:scale(.05);
		
	}
	@keyframes example {
	  0%   { transform: scale(1);opacity: 1;}
			90% {transform: scale(.08) translate(300,200);opacity: .2;}
			 /* left:  48.5%;bottom: 200px; */
			100% {opacity: 0;display: none;}
	}
	
	.operatDemo.animeKey{
	/* 	animation-name: example;
		animation-duration: 5s;
		animation-iteration-count: 1; */
		position: fixed;
		left: 48%;
		top:calc(48vh - 262px);
		z-index: 21;
		transform: scale(.07);
		transition: transform .6s,left 2s;
		/* transition: ; */
	}
	.demo1.animeKey {
		top:calc(48vh - 482px);
	} 
	.demo8.animeKey {
		top:calc(48vh - 192px);
	} 
</style>